import React from "react";
import "./timeline.css";

const Timeline = () => {
    return (
        <div className="timeline-wrapper">
            <div className="timeline-line"></div>
            <div className="timeline-item left">
                <div className="timeline-box">
                     <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>ഗുരുതി പുഷ്‌പാഞ്ജലി</h4>
                    <p>
                       എല്ലാ ചൊവ്വാഴ്ചകളിലും ഉദ്ദിഷ്ടകാര്യ സിദ്ധിക്കായി നടത്തപ്പെടുന്ന ഗുരുതി പുഷ്പാഞ്ജലി വളരെയധികം ഭക്തജനങ്ങൾ പങ്കെടുക്കുന്ന വിശേഷാൽ പൂജയാണ്. ആചാര്യ നേതൃത്വത്തിൽ ദേവി സ്‌തുതികളും മന്ത്രങ്ങളും ഭക്തജനങ്ങളെ കൊണ്ട് ഏറ്റു ചൊല്ലിച്ചു നടത്തുന്ന സമൂഹ സമർപ്പണമാണ് ഗുരുതി പുഷ്പാഞ്ജലി. ഗുരുതി പുഷ്പാഞ്ജലിയിൽ പങ്കെടുക്കുന്ന ഭക്തജനങ്ങൾക്ക് പ്രസാദത്തോടൊപ്പം വിശേഷാൽ ഔഷധക്കഞ്ഞിയും നൽകിവരുന്നു.
                    </p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>നാരങ്ങാ വിളക്ക്</h4>
                    <p>
                       രാഹുദോഷ നിവാരണത്തിനായി എല്ലാ വെള്ളിയാഴ്ചകളിലും നടത്തുന്ന നാരങ്ങാ വിളക്ക് പൂജ ഈ ക്ഷേത്രത്തിലെ മറ്റൊരു പ്രധാന ചടങ്ങാണ്. സർവവൈശ്വര്യങ്ങൾക്കും ആരോഗ്യരക്ഷയ്ക്കും വേണ്ടി നടത്തുന്ന മറ്റൊരു പ്രധാന വഴിപാടാണ് കുങ്കുമാഭിഷേകം. ശിവപ്രീതിക്ക് വേണ്ടിയും ആരോഗ്യരക്ഷയ്ക്കുവേണ്ടിയും ശിവക്ഷേത്രത്തിൽ പ്രദോഷ വ്രതവും എല്ലാ മലയാള മാസവും അവസാനത്തെ ഞായറാഴ്‌ചയും സമൂഹ മൃത്യുഞ്ജയ ഹോമവും നടത്തിവരുന്നു.
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>പടുക്ക വഴിപാട്</h4>
                    <p>കൊടിമൂട്ടിൽ ക്ഷേത്രത്തിലെ ദേവിയുടെ ഇഷ്ടവഴിപാടുകളിൽ ഒന്നാണ് പടുക്ക സമർപ്പണം. ദേവിയുടെ ഇഷ്ട നിവേദ്യങ്ങളായ തെരളിയപ്പം, ചുട്ട അട, പഴക്കുല മറ്റു പൂജാ ദ്രവ്യങ്ങൾ എന്നിവ ഭക്തജനങ്ങൾ കുട്ടകളിൽ നിറച്ച് ഭവനങ്ങളിൽ നിന്നും തലച്ചുമടുകളായി വാദ്യമേളങ്ങളുടെ അകമ്പടിയോടെ ഘോഷയാത്രയായി കൊണ്ടുവന്ന് ദേവിയ്ക്ക് സമർപ്പിക്കുന്ന ആചാരമാണ് പടുക്ക സമർപ്പണം. മുൻകാലങ്ങളിൽ ചെണ്ടമേളം, കുറ്റിവെടി എന്നിവയുടെ അകമ്പടിയോടെ ഓരോ ഭവനങ്ങളിൽ നിന്നും കൊണ്ടുവന്നിരുന്ന പടുക്കകൾ ഇപ്പോൾ പ്രാദേശികമായി ഓരോരോ കരകളിൽ നിന്ന് സംയുക്തമായി വലിയ ഘോഷയാത്ര ആയിട്ടാണ് സമർപ്പിക്കുന്നത്. കുംഭ മാസത്തിലെ ഉത്സവ നാളുകളിൽ ഒമ്പത് ദിവസവും വിവിധ കരകളിൽ നിന്നുള്ള പടുക്ക ഘോഷയാത്രകൾ സമർപ്പിക്കപ്പെടുന്നു. എല്ലാദിവസവും ക്ഷേത്രത്തിൽ പടുക്ക സമർപ്പണം നടത്താവുന്നതാണ്. വിദൂര ദേശങ്ങളിൽ നിന്നുള്ള ഭക്തജനങ്ങൾക്ക് പടുക്ക സമർപ്പണത്തിന് മുൻകൂട്ടി ബുക്ക് ചെയ്യാവുന്നതാണ്.</p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>ഉരുൾ നേർച്ച</h4>
                    <p>
                        കുംഭ മാസത്തിൽ നടക്കുന്ന വാർഷിക ഉത്സവത്തിൻ്റെ സമാപന ദിവസം വെളുപ്പിന് വിവിധ കരകളിൽ നിന്നുള്ള ഉരുൾ നേർച്ചകൾ ക്ഷേത്രത്തിൽ എത്തിച്ചേരുന്നു. ശയനപ്രദക്ഷിണത്തിനായി വ്രതം നിൽക്കുന്ന ഭക്തജനങ്ങളാണ് ഇതിൽ പങ്കെടുക്കുന്നത്. ഓരോ കരയിൽ നിന്നുമുള്ള ഉരുൾ നേർച്ചയോടൊപ്പം വിവിധങ്ങളായ വാദ്യമേളങ്ങളും കെട്ടു കാഴ്ചകളും താലപ്പൊലിയും ക്ഷേത്രത്തിൽ എത്തിച്ചേരും. ഇവയോടൊപ്പം എത്തിച്ചേരുന്ന കതിരുകാള സമർപ്പണം നാട്ടിലെ കാർഷിക അഭിവൃദ്ധിയുമായി ബന്ധപ്പെട്ട ചടങ്ങാണ്.
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>കുത്തിയോട്ടവും തോറ്റംപാട്ടും</h4>
                    <p>
                        ഭദ്രകാളീ ക്ഷേത്രങ്ങളിലെ രണ്ട് പ്രധാനപ്പെട്ട അനുഷ്‌ഠാനങ്ങളായ കുത്തിയോട്ടവും തോറ്റംപാട്ടും കൊടിമൂട്ടിൽ ക്ഷേത്രത്തിലും പരമ്പരാഗതമായി നടത്തിവരികയാണ്. ദക്ഷിണ കേരളത്തിലെ പ്രഗത്ഭരും ആചാരാനുഷ്‌ഠാനങ്ങൾ പിൻതുടരുന്നവരുമായ ദേവീ ഉപാസകരനാണ് തോറ്റംപാട്ടിൽ പങ്കെടുക്കുന്നത്. കൊടിയേറ്റിന് തൊട്ടുമുൻപുള്ള 11 ദിവസങ്ങളിലായാണ് തോറ്റം പാടി സമർപ്പിക്കുന്നത്. ക്ഷേത്രോത്സവത്തിൻ്റെ ഒൻപതാം ദിവസം വൈകുന്നേരം നിരവധി ബാലന്മാർ കുത്തിയോട്ടത്തിൽ പങ്കെടുക്കും. ക്ഷേത്രത്തിൽ കാപ്പുകെട്ടി വ്രത മെടുത്ത് നേർച്ചനിൽക്കുന്ന പതിനൊന്ന് വയസ്സിൽ താഴെയുള്ള ബാലന്മാരാണ് കുത്തിയോ ട്ടത്തിൽ പങ്കെടുക്കുന്നത്. കേരളത്തിലെ മികച്ച കുത്തിയോട്ട സംഘങ്ങളിലെ കലാകാരന്മാർ ബാലന്മാരോടൊപ്പം ചുവടുവച്ച് കുത്തിയോട്ടപാട്ടുപാടി ദേവിയ്ക്ക് കുത്തിയോട്ടം സമർപ്പിക്കും.
                    </p>
                </div>
            </div>

            {/* <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>കരിങ്കാളിയമ്മ</h4>
                    <p>
                        ചൊവ്വ, വെള്ളി, ഞായര്‍ എല്ലാ ദിവസങ്ങളില്‍ ആട്/കോഴി നേര്‍ച്ച പ്രധാനം.
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>ശാസ്താവ്</h4>
                    <p>
                        നെയ്യഭിഷേകം, ശ്രീകോവിലില്‍ നെയ്യ്നിറദീപം, നീരാഞ്ജനം, എള്ള്പായസം, കളഭാഭിഷേകം, പാല്‍പ്പായസം, ഇടിച്ചുപിഴിഞ്ഞപായസം, ഉണ്ണിയപ്പം, അരവണ, പഞ്ചാമൃതാഭിഷേകം, എണ്ണഅഭിഷേകം, അഷ്ടാഭിഷേകം, പാനകം, കരിക്കഭിഷേകം, അര്‍ച്ചനകള്‍, ഉദയാസ്തമയപൂജ, നിത്യപൂജ, സര്‍വ്വാലങ്കാരപൂജ.
                    </p>
                </div>
            </div>
            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>ഹനുമാന്‍</h4>
                    <p>
                        വെണ്ണ മുഴുക്കാപ്പ്, വടമാല, നീരാഞ്ജനം, അവല്‍നിവേദ്യം, വെറ്റിലമാല ചാര്‍ത്തല്‍, നാരങ്ങ ഹാരം ചാര്‍ത്തല്‍, തൃപ്പാദപൂജ.
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>ആയില്യപൂജ</h4>
                    <p>
                        നൂറുംപാലും, പാലഭിഷേകം, പാല്‍പ്പായസഹോമം, സര്‍പ്പബലി, നാഗരൂട്ട്‌, വിശേഷാല്‍ അഭിഷേകങ്ങള്‍.
                    </p>
                </div>
            </div> */}
        </div>
    );
};

export default Timeline;
